import React from "react";
import { Box, Typography, Stack, Divider } from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import InfoRow from "../common/InfoRow";
import AbcIcon from "@mui/icons-material/Abc";
import { CurrencyResponseDto } from "../../shared/dtos/currency/CurrencyResponseDto";

interface CurrencyCardProps {
  currency: CurrencyResponseDto;
}

const CurrencyCard: React.FC<CurrencyCardProps> = ({ currency }) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          direction="row"
          spacing={1.5}
          sx={{ alignItems: "center", mb: 1 }}
        >
          <CurrencyExchangeIcon fontSize="small" />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {currency.code}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        <Stack spacing={2} sx={{ flexGrow: 1 }}>
          <InfoRow
            icon={<AbcIcon fontSize="small" color="action" />}
            label="Currency Name"
            value={currency.name}
          />
        </Stack>
      </Box>
    </StyledCard>
  );
};

export default CurrencyCard;
